.app {
  position: absolute;
  inset: 0;
}
